module.exports = __webpack_public_path__ + "img/preimush-img-1.d70955e1.png";